import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { CategoryOutlined } from '@mui/icons-material';
import { useApplicationTypeContext } from '../../context/appType';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ConfirmDialog } from '../dialogKit';

const DeleteAppType = ({ id, name }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatchAppType } = useApplicationTypeContext();
  const { auth } = useAuthContext();
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    setBusy(true);
    setError(null);
    try {
      const response = await axiosPrivate.delete(`/api/appTypes/${id}`);
      dispatchAppType({ type: 'DELETE_APPLICATION_TYPE', payload: response.data });
      setShow(false);
    } catch (error) {
      setError(error.response?.data?.error || 'Delete failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete application type">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={busy}
        error={error}
        title="Delete application type?"
        message="This application type is removed from the list for every user."
        item={name}
        itemIcon={CategoryOutlined}
        confirmLabel="Delete type"
      />
    </>
  );
};

export default DeleteAppType;
